export default "__VITE_ASSET__f7f562b6__"